import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../../user/user-subscription";
import {IPlanInfo} from "../plan-info.interface";
import {User} from "../../../../user/user";
import {UserSubscriptionStatus} from "../../../../user/user-subscription-status";
import {Router} from "@angular/router";

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ds-plan-info',
    templateUrl: './ds-plan-info.component.html',
    styleUrls: ['./ds-plan-info.component.scss'],
    standalone: false
})
export class DsPlanInfoComponent implements OnInit {
  @Input() visitsInfo: IPlanInfo;
  @Input() backupStorageInfo: IPlanInfo;
  @Input() hostingStorageInfo: IPlanInfo;
  @Input() bandwidthInfo: IPlanInfo;
  @Input() vibeCodingInfo: IPlanInfo;
  @Input() websitesInfo: IPlanInfo;
  @Input() extraWebsitesInfo: IPlanInfo;
  @Input() generatedWebsitesInfo: IPlanInfo;
  @Input() hasUpgrade: boolean;
  userSubscription: UserSubscription;
  isDisabled = false;

  @Input('userSubscription') set userSubs(subscription: UserSubscription) {
    if (!subscription) {
      return;
    }
    this.userSubscription = subscription;
    this.isDisabled = ([this.userSubscriptionStatus.canceled, this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(subscription.status) || subscription.isExpired);
  }

  @Input() user: User;
  @Output() onAddWebsite: EventEmitter<void> = new EventEmitter<void>();
  @Output() unpause?: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onUpgradeClick?: EventEmitter<boolean> = new EventEmitter<boolean>();
  readonly UserSubscriptionType = UserSubscriptionType;
  readonly UserSubscriptionCategory = UserSubscriptionCategory;
  readonly userSubscriptionStatus = UserSubscriptionStatus;
  planSubtitle = {
    business: {
      personal: {
        title: 'The plan includes',
      },
      premium: {
        title: 'The plan includes',
      },
      enterprise: {
        title: 'The plan includes',
      },
      ['enterprise-ultimate']: {
        title: 'The plan includes',
      },
    },
    ecommerce: {
      personal: {
        title: 'The plan includes',
      },
      premium: {
        title: 'The plan includes',
      },
    },
    agency: {
      personal: {
        title: 'The plan includes',
        upgradeLimitPassed: false
      },
      premium: {
        title: 'The plan includes',
        upgradeLimitPassed: true
      },
      enterprise: {
        title: 'The plan includes',
        upgradeLimitPassed: true
      },
    }
  };
  upgradeLimitPassed = false;

  constructor(private _router: Router) {
  }

  ngOnInit() {
  }

  get subtitle() {
    const features = this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.shortFeatures;
    this.upgradeLimitPassed = !!(this.planSubtitle && this.planSubtitle[features.tabCategory] && this.planSubtitle[features.tabCategory][features.hostingPlanCategory] && this.planSubtitle[features.tabCategory][features.hostingPlanCategory].upgradeLimitPassed) || features.hostingPlanCategory === 'enterprise';
    return this.planSubtitle && this.planSubtitle[features.tabCategory] && this.planSubtitle[features.tabCategory][features.hostingPlanCategory] && this.planSubtitle[features.tabCategory][features.hostingPlanCategory].title || '';
  }

  addWebsite() {
    if (this.isDisabled) {
      return;
    }
    this.onAddWebsite.emit();
  }

  redirectToUpdate() {
    if (this.isDisabled) {
      return;
    }
    if (this.userSubscription && this.userSubscription.isDedicatedVM) {
      this.onUpgradeClick.emit(true);
      return;
    }

    this._router.navigate(['/upgrade-plan'], {queryParams: {currentUser: true}});
  }

  getVisibleStatsCount(): number {
    let count = 0;

    // Count regular stats
    if (this.userSubscription?.type !== UserSubscriptionCategory.DedicatedVM) {
      count++; // Websites stat
    }

    if (this.hostingStorageInfo) count++; // SSD storage
    if (this.visitsInfo) count++; // Monthly visitors
    if (this.bandwidthInfo?.show) count++; // CDN Bandwidth
    if (this.generatedWebsitesInfo) count++; // Generations

    // Count extra stats for API Reseller Pro
    if (this.userSubscription?.apiResellerPro) {
      if (this.extraWebsitesInfo) count++; // Extra websites
      if (this.generatedWebsitesInfo) count++; // Extra generations
    }

    return count;
  }

}
